import { useEffect, useState, useRef } from 'react';
import { Input, } from '../../../common/Forms/Input/Input';
import {
  idCodes,
  giftcardsQuantities,
  vehicleUsageOptions,
  rcvOptions,
  giftCardTypeOptions,
  LANDING,
  getKmServiceOptions,
  getPlanBaseKm,
  isNewPlanRulesActive,
  affiliationTypeOptions,
  paymentType,
  membershipCodes,
  affiliationType,
  validateCodeEnum
} from '../../../../assets/helpers/options';
import { ActionButton, AltButton } from '../../../common/Buttons/Buttons';
import { vintageYear } from '../../../../assets/helpers/const';
import { filterRCVOptions, filterParams, NaNtoNumber, filterById, filterOption, validateIfHasPublicCodes, capitalize } from '../../../../assets/helpers/funciones';
import { OderCardHeader } from './OrderComponents';
import { armorTypesService } from '../../../../services/armorTypesService';
import { codeService } from '../../../../services/codeService';
import { saleChannelService } from '../../../../services/saleChannelService';
import { giftCardService } from '../../../../services/giftCardService';
import { vehicleService } from '../../../../services/vehicleService';
import { membershipCatalogService } from '../../../../services/membershipCatalogService'; import { usersService } from '../../../../services/usersService';
import authService from '../../../../services/authService';
import { notify } from '../../../../assets/helpers/toast';
import { useHistory, useParams } from 'react-router-dom';
import './OrderComponent.scss';
import moment from 'moment';
import { toast } from 'react-toastify';

export const CreateGiftcardCard = (props) => {
  const { label, card, pay } = props;
  const { register, errors, setValue, watch, setError, control } = card.form;

  const history = useHistory();
  const { giftcardId } = useParams()

  const [salesChannelOptions, setSalesChannelOptions] = useState([]);
  const [armorTypeOptions, setArmorTypeOptions] = useState([]);
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [planOptions, setPlanOptions] = useState({
    options0: [],
    options1: [],
    options2: [],
    options3: [],
    options4: [],
    options5: [],
  });
  const [publicCodesOptions, setPublicCodesOptions] = useState({
    options0: [],
    options1: [],
    options2: [],
    options3: [],
    options4: [],
    options5: [],
  });
  const [discountCodesOptions, setDiscountCodesOptions] = useState({
    options0: "",
    options1: "",
    options2: "",
    options3: "",
    options4: "",
    options5: "",
  });

  const [open, setOpen] = useState(true);
  // Track request ids per index to ignore stale async responses
  const membershipCatalogRequests = useRef({});
  const preloadEditForm = (giftcardId) => {
    giftCardService
      .getGiftcardSales(giftcardId)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {

          setValue('saleType', "Particular");
          setValue('seller', response?.data?.sale?.seller?._id);
          setValue('saleType', "Particular");
          let aver = response?.data?.sale?.saleDate ? moment.parseZone(response.data.sale.saleDate).format('YYYY-MM-DD') : '';
          setValue('paymentDate', aver);
          setValue('email', response?.data?.sale?.customer?.email);
          setValue('phone', "+" + response?.data?.sale?.customer?.phonePrefix + response?.data?.sale?.customer?.phoneNumber);
          setValue('identificationType', response?.data?.sale?.customer?.identificationType);
          setValue('identification', response?.data?.sale?.customer?.identification);
          setValue('fullName', response?.data?.sale?.customer?.firstName);
          setValue('soldCardsCount', response?.data?.sale?.sameSaleGiftCards?.length + 1);

          loadForm(0, response);
          if (response?.data?.sale?.sameSaleGiftCards?.length > 0) {
            for (let i = 0; i < response?.data?.sale?.sameSaleGiftCards?.length; i++) {
              loadForm(i + 1, response?.data?.sale?.sameSaleGiftCards[i]);
            }
          }

        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });

  }
  const loadForm = (index, response) => {
    getmembershipCatalog(index, response?.data?.sale?.giftCard?.channel?._id || response?.channel?._id,
      response?.data?.sale?.giftCard?.appliesToMembership?._id || response?.appliesToMembership?._id
    )
    setValue(`id${index}`, response?.data?.sale?.giftCard?._id || response?._id);
    setValue(`planString${index}`, capitalize(response?.data?.sale?.giftCard?.appliesToMembership?.code) || capitalize(response?.appliesToMembership?.code));
    setValue(`rcvType${index}`, filterById(rcvOptions, response?.data?.sale?.giftCard?.rcvType || response?.rcvType)?._id);
    setValue(`affiliationType${index}`, filterOption(affiliationTypeOptions, response?.data?.sale?.giftCard?.affiliationType || response?.affiliationType)?._id);
    setValue(`saleChannel${index}`, response?.data?.sale?.giftCard?.channel?._id || response?.channel?._id);
    setValue(`vehicleYear${index}`, response?.data?.sale?.giftCard?.vehicleYear || response?.vehicleYear);
    setValue(`rcvType${index}`, filterById(rcvOptions, response?.data?.sale?.giftCard?.rcvType)?._id || response?.rcvType);
    setValue(`vehicleUsage${index}`, filterById(vehicleUsageOptions, response?.data?.sale?.giftCard?.vehicleUsage || response?.vehicleUsage)?._id);
    setValue(`vehicleClass${index}`, response?.data?.sale?.giftCard?.vehicleClass?._id || response?.vehicleClass?._id);
    setValue(`publicCode${index}`, response?.data?.sale?.giftCard?.publicCode || response?.publicCode);
    setValue(`discountCode${index}`, response?.data?.sale?.giftCard?.discountCode?.code || response?.discountCode?.code);
    // setValue(`planKm${index}`, 200);
    setTimeout(() => {
      setValue(`planKm${index}`, response?.data?.sale?.giftCard?.planKm || response?.planKm);
      setValue(`unlimitedKm${index}`, response?.data?.sale?.giftCard?.unlimitedKm || response?.unlimitedKm);
    }, 100);
    setDiscountCodesOptions(prev => {
      const next = { ...prev };
      if (response?.data?.sale?.giftCard?.discountCode?._id) {
        next[`options${index}`] = { _id: response?.data?.sale?.giftCard?.discountCode?._id } || "";
      }
      return next;
    })

    if (response?.data?.sale?.giftCard?.vehicleIsArmored || response?.vehicleIsArmored) {
      setValue(`vehicleIsArmored${index}`, "684a38c3bf5074cba17d0778");
    } else {
      setTimeout(() => {
        setValue(`vehicleIsArmored${index}`, "No");
      }, 1000);
    }

    onSelectPlan(index,
      response?.data?.sale?.giftCard?.channel?._id || response?.channel?._id,
      response?.data?.sale?.membership?._id || response?.membership?._id)
    setTimeout(() => {
      getPlanPrice(index, response?.data?.sale?.giftCard?.discountCode?._id || response?.discountCode?._id)
    }, 1000);
    setTimeout(() => {
      caldulateTotalAmount();
    }, 1000);

  }


  const preloadForm = () => {
    setValue('saleType', "Particular");
    // setValue('fullName', "Usuario Prueba");
    // setValue('email', "test@test.com");
    // setValue('phone', "+584445599");
    // setValue('identificationType', "V");
    // setValue('identification', "2344423");
    setValue('soldCardsCount', "1");

    // Preload same values for every sold card
    // const count = parseInt(watch('soldCardsCount')) || 0;
    // for (let i = 0; i < count; i++) {
    //   setValue(`rcvType${i}`, "RCV STANDARD");
    //   setValue(`vehicleIsArmored${i}`, "684a38c3bf5074cba17d0778");
    //   setValue(`saleChannel${i}`, "64690a062828e81c8fb18785");
    //   setValue(`publicCode${i}`, `PGC-0001-000${i + 1}`);
    //   setValue(`vehicleClass${i}`, "64691e105254c7956edd4db2");
    //   setValue(`vehicleYear${i}`, "2020");
    //   // setValue(`planKm${i}`, "200");
    //   setValue(`affiliationType${i}`, "Nuevo");
    //   setValue(`vehicleUsage${i}`, "Particular");
    //   setValue(`planValue${i}`, "100");
    // }
  };

  const deactivateDiscountCode = (index) => {
    setValue(`discountCodeMongo${index}`, "");
    setValue(`discountCode${index}`, "");

    setDiscountCodesOptions(prev => {
      const next = { ...prev };
      next[`options${index}`] = "";
      return next;
    });

    toast.success('Código de descuento desactivado con éxito');
    setTimeout(() => {
      getPlanPrice(index, "", true)
    }, 1500);
  }

  const validateDiscountCode = (index) => {

    let codeType = ""
    // validateCodeEnum?.NEW 
    if (watch(`affiliationType${index}`) === affiliationType?.NEW) {
      codeType = validateCodeEnum?.NEW;
    }
    if ([affiliationType?.RENEW, affiliationType?.RESCUE]?.includes(watch(`affiliationType${index}`))) {
      codeType = validateCodeEnum?.RENEWAL;
    }

    let params = {
      code: watch(`discountCode${index}`),
      type: codeType
    };

    codeService
      .validateCode(params)
      .then((response) => {
        if ([200, 201].includes(response.status)) {

          const applies = response?.data?.appliesToMemberships ?? [];
          const appliesIds = applies.map(a => String(a?._id ?? a?.id ?? a));
          if (appliesIds.includes(String(watch(`plan${index}`)))) {

            setDiscountCodesOptions(prev => {
              const next = { ...prev };
              next[`options${index}`] = response?.data ?? response;
              return next;
            });


            toast.success('Código de descuento aplicado con éxito');
            setValue(`discountCodeMongo${index}`, response?.data?._id);
            getPlanPrice(index, response?.data?._id)
          } else {
            toast.error('El código de descuento no aplica para el plan seleccionado');
          }

          //   setIsloading(false);
          //   setDiscountCode(response?.data);
        } else {
          if ([404].includes(response.status)) {
            notify(`Codigo de descuento no encontrado o expirado`, 'error');
            return null;
          }
          notify(`${response.message}`, 'error');
        }
      })
      .catch((error) => {
      });
  }

  const getArmorTypes = () => {
    armorTypesService
      .getArmorTypes()
      .then((response) => {
        if (response.status === 200) {
          response.data.push({
            _id: 'No',
            name: 'No',
          });
          setArmorTypeOptions([...response?.data]);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const resetAmount = () => {
    setValue('amount', 0);
    setValue('amountBsS', 0);

  }

  const getmembershipCatalog = (index, saleChannel, plan) => {
    setValue(`planValue${index}`, 0);

    const params = {
      withGiftCardFromChannel: saleChannel || watch(`saleChannel${index}`),
      withGiftCardType: 'Particular',
    };
    // Increment request id for this index
    const key = `idx_${index}`;
    const reqId = (membershipCatalogRequests.current[key] || 0) + 1;
    membershipCatalogRequests.current[key] = reqId;

    membershipCatalogService
      .getAvailableMemberships(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          // Ignore if a newer request started meanwhile
          if (membershipCatalogRequests.current[key] !== reqId) return;
          const memberships = response?.data?.memberships || response?.data || [];
          const mapped = memberships.map((m) => ({
            _id: m?._id ?? m?.id ?? String(m),
            name: m?.code ?? m?.name ?? m?.membershipName ?? String(m),
          }));
          setPlanOptions((prev) => ({ ...prev, [`options${index}`]: mapped }));
          setValue(`plan${index}`, plan || '');
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { /* silent */ });
  };

  const getPlanPrice = (index, discountCode, deactivateCode = false) => {
    if (watch(`rcvType${index}`) === "N/A") {
      setValue(`vehicleUsage${index}`, "");
    }

    setError(`vehicleYear${index}`, {
      type: 'custom',
      message: ``,
    });

    if (watch(`vehicleYear${index}`) && watch(`vehicleYear${index}`) > new Date().getFullYear() + 1) {
      setError(`vehicleYear${index}`, {
        type: 'custom',
        message: `Ingrese un año valido`,
      });
      return null;
    }

    if (watch(`vehicleYear${index}`) && watch(`vehicleYear${index}`) < vintageYear) {
      setError(`vehicleYear${index}`, {
        type: 'custom',
        message: `El año del vehículo debe ser mayor a ${vintageYear - 1}`,
      });
      return null;
    }

    let params = {
      year: watch(`vehicleYear${index}`),
      class: watch(`vehicleClass${index}`),
      // truckWeight: watch('truckWeight'),
      armorType: watch(`vehicleIsArmored${index}`) === "No" ? "" : watch(`vehicleIsArmored${index}`),
      discountCode: discountCode || discountCodesOptions[`options${index}`]?._id || "",
      // giftCard: giftCard?._id,
      rcv: watch(`rcvType${index}`),
      vehicleUsage: watch(`vehicleUsage${index}`),
      landing: LANDING?.PRIVATE,
      km: watch(`planKm${index}`),
      useExtendedTow: watch(`unlimitedKm${index}`),
    };

    if (deactivateCode) {
      delete params.discountCode;
    }
    // if (!watch(`vehicleYear${index}`) || !watch(`vehicleClass${index}`)) {
    //   return null;
    // }
    watch(`plan${index}`)
    // setIsloading(true);
    membershipCatalogService
      .getAvailableMemberships(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          let selectedPlan = response?.data?.find(i => i._id === watch(`plan${index}`));
          if (!selectedPlan || selectedPlan === undefined) {

            let data = {
              armorTypeSurcharge: 0,
              classSurcharge: 0,
              code: "",
              discountByCode: 0,
              discountByGiftCard: 0,
              discountToRcv: 0,
              extendedTowSurcharge: 0,
              finalPrice: 0,
              finalPriceBeforeDiscounts: 0,
              kmSurcharge: 0,
              landings: ['Publica', 'Privada', 'selfRenewal'],
              medCertSurcharge: 0,
              originalFinalPrice: 0,
              originalPrice: 0,
              rcvSurcharge: 0,
              rcvSurchargeEur: 0,
              specialOriginalPrice: 0,
              yearSurcharge: 0,
              _id: ""
            }
            setValue(`selectedPlan${index}`, data);
          } else {
            setValue(`selectedPlan${index}`, selectedPlan);
          }
          setValue(`planValue${index}`, selectedPlan?.finalPrice || 0);
          caldulateTotalAmount()
        } else {
          notify(`${response.message
            }` || 'error', 'error');
        }
      })
      .catch(() => {
      });
  };

  const onSelectPlan = (i, saleChannel, plan) => {

    getActiveGiftcards(i, saleChannel, plan);

  }

  const openPaymentSection = () => {
    setValue('billAmount', watch('amount'));
    setValue('finalPrice', watch(`amount`));
    setValue(
      'finalPriceInBsS',
      NaNtoNumber(parseFloat(watch(`finalPrice`)) * card.dollarRate).toFixed(2)
    );
    setValue('paymentMethodsQuantity', 1);
    setValue('paymentType', paymentType?.DE_CONTADO);
    setValue('amount0', watch(`amount`));
    setValue(
      'amountBsS0',
      NaNtoNumber(parseFloat(watch(`amount`)) * card.dollarRate).toFixed(2)
    );
  }

  const getActiveGiftcards = (index, saleChannel, plan,) => {

    if (!giftcardId) {
      setValue(`publicCode${index}`, '');
      setValue(`discountCode${index}`, "");
      setValue(`discountCodeMongo${index}`, "");
      setDiscountCodesOptions(prev => {
        const next = { ...prev };
        next[`options${index}`] = "";
        return next;
      });
    }
    setValue(`unlimitedKm${index}`, false);

    if (filterById(planOptions?.[`options${index}`] || [], watch(`plan${index}`))?.name === membershipCodes?.GOLD) {
      setValue(`planKm${index}`, getPlanBaseKm(membershipCodes?.GOLD));
    } else {
      setValue(`planKm${index}`, "");
    }

    let params = {
      saleChannel: saleChannel || watch(`saleChannel${index}`),
      type: "Particular",
      membership: plan || watch(`plan${index}`),
    };

    if (!giftcardId && (!watch(`saleChannel${index}`) || !watch(`plan${index}`))) {
      return null;
    }

    giftCardService
      .getActiveGiftcards(params)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {

          // update publicCodesOptions for the specific index based on response
          const codes = response?.data?.publicCodes || response?.data || [];
          const membershipId = watch(`plan${index}`);

          // non-functional update (create a shallow copy and replace the slot)
          const nextData = { ...publicCodesOptions };
          nextData[`options${index}`] = codes
            .filter(pc => !membershipId || pc?.membershipId === membershipId)
            .map(pc => ({
              _id: pc?.publicCode ?? pc?._id ?? String(pc),
              name: String(pc?.publicCode ?? pc?.publicCode ?? ''),
            }));
          setPublicCodesOptions(nextData);

          // functional update to be safe with concurrent state updates
          setPublicCodesOptions(prev => {
            const next = { ...prev };
            next[`options${index}`] = codes
              .filter(pc => !membershipId || pc?.membershipId === membershipId)
              .map(pc => ({
                _id: pc?.publicCode ?? pc?._id,
                name: String(pc?.publicCode ?? ''),
              }));
            return next;
          });

        } else {
          notify(`${response.message}` || 'error', 'error');
          notify(`No existen codigos internos dispobibles`, 'info');
        }
      })
      .catch(() => { });
  }

  const caldulateTotalAmount = () => {
    let total = 0;
    let hasValue = 0
    const count = parseInt(watch('soldCardsCount')) || 0;
    for (let i = 0; i < count; i++) {
      let planValue = parseFloat(watch(`planValue${i}`)) || 0;
      let publicCode = parseFloat(watch(`publicCode${i}`)) || 0;
      total += planValue;
      if (planValue >= 0 && publicCode) {
        hasValue = hasValue + 1
      }
      if (hasValue === count && total > 0) {
        setValue('amount', total);
        setValue('amountBsS', (total * parseFloat(card.dollarRate))?.toFixed(2));
      }
    }
  }




  const getSalesChannel = () => {

    saleChannelService
      .getSalesChannel()
      .then((response) => {
        if (response.status === 200) {
          setSalesChannelOptions(response?.data?.saleChannels);
          // setValue('salesChannel', user?.saleChannel);
          setTimeout(() => { }, 500);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getSalesVehicleClasses = () => {
    vehicleService
      .getSalesVehicleClasses()
      .then((response) => {
        if (response.status === 200) {
          setVehicleClassesOptions(response?.data?.classes);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };



  const handlePaymentDateRate = () => {
    card.onChange?.getPaymentDateRate()
  }


  useEffect(() => {
    getSalesChannel()
    getArmorTypes()
    getSalesVehicleClasses()

    if (giftcardId) {
      setTimeout(() => {
        preloadEditForm(giftcardId)
      }, 2500);
    } else {
      setTimeout(() => {
        preloadForm();
      }, 1500);
    }
  }, [open]);
  return (
    <>
      <div className="col-12">
        <div className="order-card">
          <OderCardHeader open={open} setOpen={setOpen} label={label} />

          {open && (
            <>
              <br />
              <div style={{ width: '100%' }} className="row">
                <div className="row">
                  <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                  <h6 style={{ margin: '6px 12px 12px 0px' }}>
                    DATOS DEL CLIENTE
                  </h6>
                  <Input
                    bootstrap={'col-12 col-sm-6 col-md-3'}
                    label={'Tipo de Venta'}
                    type={'select'}
                    options={giftCardTypeOptions}
                    name={'saleType'}
                    register={register}
                    placeholder={''}
                    errors={errors?.saleType?.message}
                    disabled={true}
                  />
                  <Input
                    bootstrap={'col-12 col-sm-6 col-md-3'}
                    label={'Asesor'}
                    type={'select'}
                    options={card?.options?.sellerOptions}
                    name={'seller'}
                    register={register}
                    placeholder={''}
                    errors={errors?.seller?.message}
                    disabled={watch("finalPrice")}
                  />
                  <Input
                    bootstrap={'col-12 col-sm-6 col-md-3'}
                    label={'Fecha de Venta *'}
                    type={'birthday'}
                    name={'paymentDate'}
                    register={register}
                    capitalizeOff={true}
                    placeholder={''}
                    control={control}
                    errors={errors?.paymentDate?.message}
                    onChange={() => handlePaymentDateRate()}
                    disabled={watch("paymentMethodsQuantity")}
                  />
                  <Input
                    bootstrap={'col-12 col-sm-6 col-md-3'}
                    label={'Cantidad de Tarjetas Vendidas'}
                    type={'select'}
                    options={giftcardsQuantities}
                    name={'soldCardsCount'}
                    register={register}
                    placeholder={''}
                    errors={errors?.soldCardsCount?.message}
                    onChange={() => resetAmount()}
                  />
                  <Input
                    bootstrap={'col-12 col-sm-6 col-md-3'}
                    label={'Nombre y Apellido (Cliente)'}
                    type={'text'}
                    name={'fullName'}
                    register={register}
                    placeholder={''}
                    errors={errors?.fullName?.message}
                    disabled={watch("finalPrice")}
                  />
                  <Input
                    bootstrap={'col-4 col-sm-2 col-md-1'}
                    label={'C.I / RIF*'}
                    type={'select'}
                    name={'identificationType'}
                    register={register}
                    placeholder={''}
                    options={idCodes}
                    errors={errors?.identificationType?.message}
                    disabled={watch("finalPrice")}
                  />
                  <Input
                    bootstrap={'col-8 col-sm-4 col-md-2'}
                    label={'del cliente*'}
                    type={'number'}
                    name={'identification'}
                    register={register}
                    placeholder={''}
                    errors={errors?.identification?.message}
                    disabled={watch("finalPrice")}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-sm-6 col-md-3'}
                    label={'Teléfono *'}
                    type={'phone'}
                    control={control}
                    name={'phone'}
                    register={register}
                    placeholder={''}
                    // options={phoneCodes}
                    errors={errors?.phone?.message}
                    disabled={watch("finalPrice")}
                  />
                  <Input
                    bootstrap={'col-12 col-sm-6 col-md-3'}
                    label={'Email *'}
                    type={'text'}
                    name={'email'}
                    register={register}
                    placeholder={''}
                    errors={errors?.email?.message}
                    disabled={watch("finalPrice")}
                  />


                  {parseFloat(watch("soldCardsCount")) > 0 && Array.from({ length: watch("soldCardsCount") }).map((_, i) => (
                    <>
                      <h6 style={{ marginTop: "24px" }}>
                        Tarjeta {i + 1}
                      </h6>
                      <Input
                        bootstrap={'col-12 col-sm-6 col-md-2'}
                        label={'Tipo de Afiliacion'}
                        type={'select'}
                        options={affiliationTypeOptions}
                        name={`affiliationType${i}`}
                        register={register}
                        placeholder={''}
                        errors={errors?.[`affiliationType${i}`]?.message}
                        disabled={watch("finalPrice") || (giftcardId && watch(`publicCode${i}`))}

                      />
                      <Input
                        bootstrap={'col-12 col-sm-6 col-md-2'}
                        label={'Canal de Venta'}
                        options={salesChannelOptions}
                        type={'select'}
                        name={`saleChannel${i}`}
                        register={register}
                        placeholder={''}
                        errors={errors?.[`saleChannel${i}`]?.message}
                        disabled={watch("finalPrice") || (giftcardId && watch(`publicCode${i}`))}
                        onChange={() => {
                          getmembershipCatalog(i)
                        }}
                      />
                      {watch(`planString${i}`) ?
                        <Input
                          bootstrap={'col-12 col-sm-6 col-md-2'}
                          label={'Plan'}
                          type={'text'}
                          options={planOptions?.[`options${i}`] || []}
                          name={`planString${i}`}
                          register={register}
                          placeholder={''}
                          disabled={!watch(`saleChannel${i}`) || watch("finalPrice") || planOptions?.[`options${i}`]?.length === 0 || giftcardId}
                          onChange={() => onSelectPlan(i)}
                          errors={errors?.[`planString${i}`]?.message}
                        /> :
                        <Input
                          bootstrap={'col-12 col-sm-6 col-md-2'}
                          label={'Plan'}
                          type={'select'}
                          options={planOptions?.[`options${i}`] || []}
                          name={`plan${i}`}
                          register={register}
                          placeholder={''}
                          disabled={!watch(`saleChannel${i}`) || watch("finalPrice") || planOptions?.[`options${i}`]?.length === 0 || (giftcardId && watch(`publicCode${i}`))}
                          onChange={() => onSelectPlan(i)}
                          errors={errors?.[`plan${i}`]?.message}
                        />
                      }
                      {watch(`planString${i}`) ?
                        <Input
                          bootstrap={'col-12 col-sm-6 col-md-2'}
                          label={'Código Público 1'}
                          type={'text'}
                          options={publicCodesOptions?.[`options${i}`] || []}
                          name={`publicCode${i}`}
                          register={register}
                          placeholder={''}
                          errors={errors?.[`publicCode${i}`]?.message}
                          disabled={true}
                        />
                        :
                        <Input
                          bootstrap={'col-12 col-sm-6 col-md-2'}
                          label={'Código Público 2'}
                          type={'select'}
                          options={publicCodesOptions?.[`options${i}`] || []}
                          name={`publicCode${i}`}
                          register={register}
                          placeholder={''}
                          errors={errors?.[`publicCode${i}`]?.message}
                          onChange={() => getPlanPrice(i)}
                          disabled={publicCodesOptions?.[`options${i}`]?.length === 0 || watch("paymentType") || !watch(`plan${i}`) || (giftcardId && watch(`publicCode${i}`))}
                        />
                      }
                      <Input
                        bootstrap={'col-12 col-sm-6 col-md-2'}
                        label={'Clase del vehículo *'}
                        type={'select'}
                        name={`vehicleClass${i}`}
                        options={vehicleClassesOptions}
                        register={register}
                        placeholder={''}
                        errors={errors?.[`vehicleClass${i}`]?.message}
                        onChange={() => getPlanPrice(i)}
                        disabled={watch("finalPrice")}
                      />

                      <Input
                        bootstrap={'col-12 col-sm-6 col-md-2'}
                        label={'Año del vehículo *'}
                        type={'number'}
                        name={`vehicleYear${i}`}
                        register={register}
                        placeholder={''}
                        errors={errors?.[`vehicleYear${i}`]?.message}
                        onChange={() => getPlanPrice(i)}
                        disabled={watch("finalPrice")}
                      />
                      <Input
                        bootstrap={'col-12 col-sm-6 col-md-2'}
                        label={'Blindaje *'}
                        type={'select'}
                        name={`vehicleIsArmored${i}`}
                        options={armorTypeOptions}
                        register={register}
                        placeholder={''}
                        errors={errors?.[`vehicleIsArmored${i}`]?.message}
                        onChange={() => getPlanPrice(i)}
                        disabled={watch("finalPrice")}
                      />
                      <Input
                        bootstrap={'col-12 col-sm-6 col-md-2'}
                        label={'Tipo de RCV *'}
                        type={'select'}
                        options={filterRCVOptions(rcvOptions)}
                        name={`rcvType${i}`}
                        register={register}
                        placeholder={''}
                        errors={errors?.[`rcvType${i}`]?.message}
                        onChange={() => getPlanPrice(i)}
                        disabled={watch("finalPrice")}
                      />
                      {watch(`rcvType${i}`) !== "N/A" &&
                        <Input
                          bootstrap={'col-12 col-sm-6 col-md-2'}
                          label={'Uso del Vehículo *'}
                          type={'select'}
                          options={vehicleUsageOptions}
                          name={`vehicleUsage${i}`}
                          register={register}
                          placeholder={''}
                          errors={errors?.[`vehicleUsage${i}`]?.message}
                          onChange={() => getPlanPrice(i)}
                          disabled={watch("finalPrice")}
                        />
                      }
                      {((filterById(planOptions?.[`options${i}`] || [], watch(`plan${i}`))?.name === membershipCodes?.GOLD)
                        || (watch(`planString${i}`) === capitalize(membershipCodes?.GOLD))) &&
                        <Input
                          bootstrap={'col-12 col-sm-6 col-md-2'}
                          label={'Km del Plan *'}
                          type={'select'}
                          name={`planKm${i}`}
                          register={register}
                          placeholder={''}
                          options={
                            // Giftcards ya emitidas con 200 km conservan su valor visible
                            isNewPlanRulesActive() && Number(watch(`planKm${i}`)) === 200
                              ? [{ name: '200 Km', _id: 200 }, ...getKmServiceOptions(200)]
                              : getKmServiceOptions(watch(`planKm${i}`))
                          }
                          errors={errors?.[`planKm${i}`]?.message}
                          onChange={() => getPlanPrice(i)}
                          disabled={watch("finalPrice")}
                        />
                      }
                      {((filterById(planOptions?.[`options${i}`] || [], watch(`plan${i}`))?.name === membershipCodes?.GOLD)
                        || (watch(`planString${i}`) === capitalize(membershipCodes?.GOLD))) &&
                        <Input
                          bootstrap={'col-12 col-sm-6 col-md-2'}
                          subLabel={
                            isNewPlanRulesActive()
                              ? 'Servicios de grúa ilimitados'
                              : 'Km Ilimitado'
                          }
                          type={'checkbox'}
                          name={`unlimitedKm${i}`}
                          register={register}
                          placeholder={''}
                          errors={errors?.[`unlimitedKm${i}`]?.message}
                          onChange={() => getPlanPrice(i)}
                        />
                      }
                      <Input
                        bootstrap={'col-12 col-sm-6 col-md-2'}
                        label={'Valor del Plan'}
                        type={'number'}
                        name={`planValue${i}`}
                        register={register}
                        placeholder={''}
                        errors={errors?.[`planValue${i}`]?.message}
                        disabled={true}
                      />
                      <Input
                        bootstrap={'col-12 col-sm-6 col-md-2'}
                        label={'Codigo de Descuento'}
                        type={'text'}
                        name={`discountCode${i}`}
                        register={register}
                        placeholder={''}
                        errors={errors?.[`discountCode${i}`]?.message}
                        disabled={!watch(`plan${i}`) || discountCodesOptions[`options${i}`]}
                      />
                      {watch(`discountCode${i}`) && watch(`planString${i}`) && !watch(`discountCodeMongo${i}`) && discountCodesOptions[`options${i}`] &&
                        <div className='col-12 col-sm-6 col-md-2'>
                          <div div style={{ marginTop: "32px" }} className="buttons-container">
                            <ActionButton type="button"
                              label={'Desactivar Descuento'}
                              action={() => deactivateDiscountCode(i)}
                            />
                          </div>
                        </div>
                      }
                      <div>
                        <h6>Codigo de descuento valido para {discountCodesOptions[`options${i}`]?.appliesToMemberships?.map(i =>
                          i?.code + " "
                        )}</h6>
                      </div>
                      <div className='col-12 col-sm-6 col-md-2'>
                        {watch(`discountCode${i}`) && !discountCodesOptions[`options${i}`] &&
                          <div div style={{ marginTop: "32px" }} className="buttons-container">
                            <ActionButton type="button"
                              label={'Canjear Descuento'}
                              action={() => validateDiscountCode(i)}
                            />
                          </div>
                        }
                      </div >
                    </>
                  ))}
                  <h6 style={{ marginTop: "24px" }}>
                    Total a Pagar
                  </h6>
                  <Input
                    bootstrap={'col-12 col-sm-6 col-md-2'}
                    label={'Monto USD'}
                    type={'number'}
                    name={'amount'}
                    register={register}
                    placeholder={''}
                    errors={errors?.amount?.message}
                    disabled={true}
                  />
                  <Input
                    bootstrap={'col-12 col-sm-6 col-md-2'}
                    label={'Monto Bs'}
                    type={'number'}
                    name={'amountBsS'}
                    register={register}
                    placeholder={''}
                    errors={errors?.amountBsS?.message}
                    disabled={true}
                  />

                  {parseFloat(watch("amount")) >= 0 && validateIfHasPublicCodes(watch) && !watch("finalPrice") && giftcardId &&
                    <div className="col-12 col-sm-6 col-md-4">
                      <div style={{ marginTop: "32px" }} className="buttons-center-container">
                        <ActionButton type="button"
                          label={'Editar'}
                          action={() => pay()}
                        />
                        <AltButton type="button"
                          label={'Cancelar'}
                          action={() => history.push('/modules/giftcard-sales')}
                        />
                      </div>
                    </div>
                  }
                  {parseFloat(watch("amount")) >= 0 && validateIfHasPublicCodes(watch) && !watch("finalPrice") && !giftcardId &&
                    <div className="col-12 col-sm-6 col-md-4">
                      <div style={{ marginTop: "32px" }} className="buttons-center-container">
                        <ActionButton type="button"
                          label={'Pagar'}
                          action={() => openPaymentSection()}
                        />
                        <AltButton type="button"
                          label={'Cancelar'}
                          action={() => history.push('/modules/giftcard-sales')}
                        />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </>
          )}
        </div>
      </div >
    </>
  );
};
